import {get, post, del, put} from '@/services/api'

const state = {
    didLoadedPlaces: false,
    didLoadedPlace: false,
    places: [],
    types: [
        {title: "Oddělení", value: "department"},
        {title: "Kancelář", value: "office"},
        {title: "Sklad", value: "utility_room"},
        {title: "Studovna", value: "study_room"},
        {title: "Kantýna", value: "cafeteria"},
        {title: "Terasa", value: "terrace"},
        {title: "Automat na lístky", value: "ticket_machine"},
        {title: "Jídelní automat", value: "food_machine"},
        {title: "Vnitro budovy", value: "indoor_building"},
        {title: "Prázdný prostor", value: "empty"},
        {title: "Zastávka MHD", value: "transportation_stop"},
        {title: "Zahrada", value: "garden"},
        {title: "Sklad", value: "storage"},
        {title: "Zasedací místnost", value: "boardroom"},
        {title: "Koleje", value: "dormitory"},
        {title: "Pitná voda", value: "water_machine"},
        {title: "Dámské toalety", value: "toilet_female"},
        {title: "Podlaha", value: "floor"},
        {title: "Vrátnice", value: "gatehouse"},
        {title: "Toaleta", value: "toilet"},
        {title: "Strojovna", value: "engine_room"},
        {title: "Počítačový kiosek", value: "computer_kiosk"},
        {title: "Dřez", value: "sink"},
        {title: "Nouzový východ", value: "emergency_floor"},
        {title: "Učebna a laboratoř", value: "classroom_and_laboratory"},
        {title: "Kopírka", value: "copier"},
        {title: "Obvod", value: "outline"},
        {title: "Skříňka", value: "locker"},
        {title: "Šachta", value: "shaft"},
        {title: "Přízemí", value: "ground"},
        {title: "Šatna", value: "coatroom"},
        {title: "Schody", value: "stairs"},
        {title: "Výtah", value: "elevator"},
        {title: "Pánské toalety", value: "toilet_male"},
        {title: "Chodník", value: "walk"},
        {title: "Parkoviště", value: "parking"},
        {title: "Zeď", value: "wall"},
        {title: "Archiv", value: "archive"},
        {title: "Kávový automat", value: "cafe_machine"},
        {title: "Bistro", value: "bistro"},
        {title: "Kuchyně", value: "kitchen"},
        {title: "Garáž", value: "garage"},
        {title: "Brána", value: "gate"},
        {title: "Budova", value: "building"},
        {title: "Knihovna", value: "library"},
        {title: "Nouzové schody", value: "emergency_stairs"},
        {title: "Odpadkový koš", value: "trashcan"},
        {title: "Toaleta pro handicapované", value: "toilet_handicapped"},
        {title: "Pokoj", value: "room"},
        {title: "Pizzerie", value: "pizzeria"},
        {title: "Vydavatelství", value: "publishing_house"},
        {title: "Vinárna", value: "wine_shop"},
        {title: "Odpadky", value: "garbage"},
        {title: "Obvod patra", value: "base"},

        //01.10.21 TYPES
        {title: "Okenní rám", value: "window_frame"},
        {title: "Dveře", value: "door"},
        {title: "Balkón", value: "balcony"},
        {title: "Sprcha", value: "shower"},

        //18.02.22 TYPES
        {title: "Přípravná místnost", value: "preparatory"},
        {title: "Rozvodná místnost", value: "substation"},
        {title: "Lobby", value: "lobby"},
        {title: "Reprezentativní prostor", value: "representative_space"},
        {title: "Kulturní prostory", value: "cultural_space"},
        {title: "Regulační stanice", value: "regulatory_station"},

        //12.05.22 TYPES
        {title: "Nevyužívané", value: "not_used"},
        {title: "Dílna", value: "workshop"},
        {title: "Hala", value: "hall"},

        //03.08.22 TYPES
        {title: "Koupelna", value: "bathroom"},

        //30.09.22 TYPES
        {title: "Anglický dvorek", value: "english_backyard"},
        {title: "Denní místnost", value: "daily_room"},
        {title: "Sklad potravin", value: "food_storage"},
        {title: "Výdejna jídla", value: "food_serving"},
        {title: "Místnost na mytí nádobí", value: "dish_washing_room"},
        {title: "Jídelna", value: "dining_room"},
        {title: "Rampa", value: "ramp"},

        //09.08.23 TYPES
        {title: "Serverovna", value: "server_room"},
    ],
    floors: [
        {title: "5", value: 8},
        {title: "4", value: 9},
        {title: "3", value: 10},
        {title: "2", value: 11},
        {title: "1", value: 12},
        {title: "0", value: 13},
        {title: "-1", value: 14},
        {title: "-2", value: 15}
    ],
    headersOfTable: [
        {
            title: 'ID',
            align: 'start',
            value: 'id',
            width: "10%",
            filterable: true
        },
        {
            title: 'Název',
            align: 'left',
            value: 'name',
            width: "35%",
            filterable: true
        },
        {
            title: 'Typ',
            align: 'left',
            value: 'type',
            width: "20%",
            filterable: false,
        },
        {
            title: 'Podlaží',
            align: 'center',
            value: 'floorId',
            width: "15%",
            filterable: false
        },
        {
            title: 'Upraveno',
            align: 'left',
            value: 'lastUpdate',
            width: "20%",
            filterable: false
        },
    ],
    days: ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"],
    place: null,
    newPlace: null,
    processing: false,
    objectsOfCertainFloor: [],
    buildings: [],
    buildingNames: ["Budova Q", "Exteriér"],
    placeImages: [],
    totalItemCount: null,
};

const getters = {
    didLoadedPlaces: state => state.didLoadedPlaces,
    didLoadedPlace: state => state.didLoadedPlace,
    isProcessing: state => state.processing,
    getPlaces: state => state.places,
    placeById: state => id => state.places.find(p => p.id === id),
    getPlace: state => state.place,
    placeByBeaconId: state => item => state.places.find(place => place.id === item.placeId),
    getPlacesTypes: state => state.types,
    getTypeName: state => typeName => {
        const type = state.types.find(el => el.value === typeName);
        return type ? type.title : '';
    },
    getHeadersOfTable: state => state.headersOfTable,
    getDays: state => state.days,
    getObjectsOfCertainFloor: state => state.objectsOfCertainFloor,
    constructNewPlace: () => () => ({
        "id": "new",
        "accessType": null,
        "clickable": false,
        "code": null,
        "computerWithProjector": null,
        "localizedAttributes": {
            "cz": {
                name: "",
                nickname: "",
                description: "",
            },
            "en": {
                name: "",
                nickname: "",
                description: "",
            },
        },
        "email": null,
        "floorId": null,
        "numberOfSeats": null,
        "numberOfImages": 0,
        "openHours": [],
        "person1Id": null,
        "person2Id": null,
        "phone": null,
        "position": [],
        "searchable": true,
        "type": null,
        "url": null,
        "whiteboard": null,
        "created": new Date().toJSON().slice(0, 10).replace(/-/g, ''),
    }),
    getNewPlace: state => state.newPlace,
    getPlaceImages: state => state.placeImages,
    createEmptyCoordinate: () => () => ({
        lat: null,
        lon: null,
        order: 0,
    }),
    getUniversityPosition: () => () => ({
        lat: 49.210759,
        lon: 16.615506,
        order: 0,
    }),
    placesByFloor: state => floorId => state.places.filter(place => place.floorId === floorId),

    /**
     * Returns the first place that matches the given name ignoring case.
     * @param {string} name
     * @param {string} language Specify, which localized version of the name to use for comparison. Default is `cz`.
     * @returns One place or undefined.
     */
    getPlaceByName: state => (name, language = 'cz') => {
        const sanitizedName = name.toLowerCase();
        return state.places.find(p =>
            p.localizedAttributes[language] && p.localizedAttributes[language].name.toLowerCase() == sanitizedName
        );
    },
    getFirstPlace: state => state.places[0],
    getTotalItemCount: state => state.totalItemCount,
};

const actions = {

    // fetches all places unless they are already in store
    async fetchPlaces({commit}) {
        commit('setDidLoadedPlaces', false);
        await get('map/places/')
            .then((response) => {
                commit('setPlaces', response.data.items);
                commit('setDidLoadedPlaces', true);
                commit('updateBuildingPlaces');
            });
    },

    async fetchPlacesByPageAndItemsPerPage({commit}, {searchString = null, language = null,
        buildingId = null, floorId = null, exterior = null, placeType = null, page = null, itemsPerPage = null}) {

        commit('setDidLoadedPlaces', false);
        try {
            let url = 'map/places/?';
            if ( searchString != null && language != null)
                url = `${url}&search=${searchString}&language=${language}`;

            if (page != null && itemsPerPage != null && itemsPerPage > 0)
                url = `${url}&page=${page - 1}&itemsPerPage=${itemsPerPage}`;

            if (buildingId == null && floorId == null && exterior === true)
                url = `${url}&exterior=true`;

            if (buildingId != null && floorId == null && exterior !== true)
                url = `${url}&buildingId=${buildingId}`;

            if (buildingId == null && floorId != null && floorId !== '' && exterior !== true)
                url = `${url}&floorId=${floorId}`;

            const placeTypeVal = placeType == null ? '' : placeType;
            url = `${url}&placeType=${placeTypeVal}`;

            const response = await get(url);

            commit('setPlaces', response.data.items);
            commit('setTotalItemCount', response.data.count);
            commit('setDidLoadedPlaces', true);
            commit('updateBuildingPlaces');
        } catch (e) {
            console.log(e)
        }
    },

    async fetchFilteredPlaces({commit}, {floorId, buildingId, exterior, placeName, language}) {
        commit('setDidLoadedPlaces', false);
        try {
            let response;
            if (floorId !== null && buildingId === null && exterior === null && placeName === null && language === null)
                response = await get(`map/places/?floorId=${floorId}`);

            else if (floorId === null && buildingId !== null && exterior === null && placeName === null && language === null)
                response = await get(`map/places/?buildingId=${buildingId}`);

            else if (floorId === null && buildingId === null && exterior !== null && placeName === null && language === null)
                response = await get(`map/places/?exterior=${exterior}`);

            else if (floorId === null && buildingId === null && exterior === null && placeName !== null && language !== null)
                response = await get(`map/places/?language=${language}&placeName=${placeName}`);
            else {
                console.log("Unexpected arguments");
                return;
            }

            commit('setPlaces', response.data.items);
            commit('setDidLoadedPlaces', true);
            commit('updateBuildingPlaces');
        } catch (e) {
            console.log(e)
        }
    },

    // fetches one places into map view
    async fetchPlace({commit}, id) {
        commit('errors/clear', null, {root: true});
        commit('setDidLoadedPlace', false);
        await Promise.all([
            get(`map/places/${id}`),
            get(`map/images/${id}`)
        ]).then((response) => {
            commit('setPlace', response[0].data.content);
            commit('setImages', response[1].data.items);
            commit('setDidLoadedPlace', true);
        }).catch(e => {
            if (e.statusCode == 404) {
                commit('errors/objectNotFound', null, {root: true});
            } else {
                throw e;
            }
        })
    },

    async fetchFloor({commit}, floor) {
        if (state.places.length === 0) {
            const response = await get('map/places/');
            const responseFloors = response.data.items.filter(place => place.floorId === floor);
            commit('setObjectsOfCertainFloor', responseFloors);
        } else {
            commit('filterFloorsIfPlacesFetched', floor);
        }
    },

    // updates place after saving changes
    async updatePlace({commit}, {id, item}) {
        return new Promise((resolve) => {
            put(`map/places/${id}`, item)
                .then((item) => {
                    commit('updateBuildingPlaces');
                    commit('updatePlace', item.data.content);
                    resolve(item.data.content);
                });
        });
    },

    // deletes one selected place
    async deletePlace({commit}, id) {
        await del(`map/places/${id}`);
        commit('updateBuildingPlaces');
        commit('filterPlaces', id);
    },

    // creates new place
    async postPlace({commit}, {place}) {
        return new Promise((resolve) => {
            commit('setProcessing', true);
            post('map/places/', place).then((response) => {
                commit('addPlace', response.data.content);
                commit('updateBuildingPlaces');
                resolve(response.data.content);
            });
        });
    },

    createNewPlace({commit}) {
        commit('setImages', []);
        commit('setNewPlace', getters.constructNewPlace()());
    },

    async fetchImages({commit}, id) {
        try {
            const response = await get(`map/images/${id}`)
            commit('setImages',response.data.items)
        } catch (e) {
            console.error(e);
        }
    },
};

const mutations = {
    setDidLoadedPlaces: (state, value) => {
        state.didLoadedPlaces = value;
    },
    setDidLoadedPlace: (state, value) => {
        state.didLoadedPlace = value;
    },
    setProcessing: (state, value) => {
        state.processing = value;
    },
    updatePlace: (state, item) => {
        let index = state.places.findIndex(place => place.id === item.id);
        state.places[index] = item;
    },
    setPlaces: (state, places) => (state.places = places),
    addImage: (state, image) => (state.placeImages.push(image)),
    setImages: (state, images) => (state.placeImages = images),
    setPlace: (state, place) => (state.place = place),
    filterPlaces: (state, id) => (state.places = state.places.filter(places => places.id !== id)),
    addPlace: (state, place) => {
        state.places.push(place);
    },
    setObjectsOfCertainFloor: (state, value) => (state.objectsOfCertainFloor = value),
    filterFloorsIfPlacesFetched: (state, floor) => (state.objectsOfCertainFloor = (state.places.filter(place => place.floorId === floor))),
    setNewPlace: (state, value) => (state.newPlace = value),
    updateBuildingPlaces: (state) => {
        let b = [];
        let o = [];
        state.buildings = [];
        state.places.forEach(place => {
            if (place.floorId !== null) {
                b.push(place);    //place is a part of bulding Q
            } else {
                o.push(place);    //place is a part of exterior
            }
        });
        state.buildings.push({title: "Budova Q", value: b});
        state.buildings.push({title: "Exterier", value: o});
    },
    removeImage: (state, id) => state.placeImages = state.placeImages.filter(i => i.id !== id),
    setTotalItemCount: (state, count) => state.totalItemCount = count,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
